import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static post(postId) {
        return PostApiBase.post({
            "post_id": postId,
        })
    }
}
